export default __webpack_public_path__ + "static/media/capstone_dashboard.c93d3dd5.png";